import React from 'react';
import {View} from 'react-native';
import {makeStyles} from '@rneui/themed';

import Text from '../../../components/ui-controls/Text';
import {useWebScreenDimensions} from '../../../hooks/useWebScreenDimensions';
import WineBottleEmpty from '../../../images/svg/rewards/wine_bottle_empty.svg';
import WineBottleFilled from '../../../images/svg/rewards/wine_bottle_filled.svg';
import theme from '../../../style/theme';
import {
  CoffeeCardOffersItem,
} from '../../../transport/types';

type CoffeeCardProps = {
  offer: CoffeeCardOffersItem;
};

const CoffeeCard = ({offer}: CoffeeCardProps) => {
  const styles = useStyles();
  const {purchased_quantity, target_quantity} = offer.coffeeCardStats;

  const filledSlots = Math.min(purchased_quantity, target_quantity);
  const remainingSlots = Math.max(0, target_quantity - purchased_quantity);

  return (
    <View testID="coffee-card" style={styles.container}>
      <Progress filledSlots={filledSlots} remainingSlots={remainingSlots} />
      <Text
        style={
          styles.progressText
        }>{`You've bought ${filledSlots} out of ${target_quantity} drinks`}</Text>
    </View>
  );
};

const Progress = ({
  filledSlots,
  remainingSlots,
}: {
  filledSlots: number;
  remainingSlots: number;
}) => {
  const {isWebDesktopScreen} = useWebScreenDimensions();
  const styles = useStyles({isWebDesktopScreen});

  return (
    <View testID="coffee-card-progress" style={styles.progressContainer}>
      {[...Array(filledSlots)].map((_, index) => (
        <WineBottleFilled key={index} style={styles.stamp} />
      ))}
      {[...Array(remainingSlots)].map((_, index) => (
        <WineBottleEmpty key={index} style={styles.stamp} />
      ))}
    </View>
  );
};

const useStyles = makeStyles(
  (_theme, {isWebDesktopScreen}: {isWebDesktopScreen?: boolean}) => {
    const spaceMultiplier = isWebDesktopScreen ? 2 : 1;
    return {
      container: {
        flexDirection: 'column',
        marginTop: 8 * spaceMultiplier,
        marginBottom: 16 * spaceMultiplier,
      },
      progressText: {
        textAlign: 'center',
      },
      progressContainer: {
        flexDirection: 'row',
        justifyContent: 'center',
        gap: isWebDesktopScreen ? 12 : 8,
        marginBottom: 8 * spaceMultiplier,
      },
      stamp: {
        height: isWebDesktopScreen ? 200 : 130,
        fill: theme.colour.general.primary,
      },
    };
  },
);

export default CoffeeCard;
